import React, { Component } from 'react'
import { observer, Provider } from 'mobx-react'
import { HeaderView } from '@merchant-backend/common-components'
import DashBoard from './DashBoard'
import Tabs from './Tabs'
import { Flex } from 'hljd'
import Panel from '@common/Panel'
import { Alert } from 'hljd'
import Store from './store'
import PackageList from './PackageList'
import Competition from './Competition'
import { Link } from 'react-router'
import { MATERIAL_PATH } from '@constant'
import DeliveryMode from './DeliveryMode'

@observer
export default class extends Component {
  constructor(props) {
    super(props)
    this.store = new Store()
  }

  componentDidMount() {
    this.store.getData()
  }

  getAlert = warn => {
    const showNoCreativeTip = warn.tip == 1

    if (showNoCreativeTip) {
      return (
        <Alert
          message={
            <span>
              暂无可使用的推广创意，请在套包生效前，前往<Link
                to={MATERIAL_PATH}
              >
                创意中心
              </Link>创建创意。创意审核通过后，将被智推宝自动抓取。
            </span>
          }
          type="warning"
          showIcon
        />
      )
    }

    return (
      <Alert
        message={
          <span>
            同时使用3个及以上套包，可额外获赠流量！3个包额外附赠10%，4个套包额外附赠11%……依次类推无上限！
            <a onClick={this.store.tabsStore.changeToPackageTab}>立即激活</a>
          </span>
        }
        type="warning"
        showIcon
      />
    )
  }

  getServiceAlert = warn => {
    const showServiceTip = warn.has_service_down_time

    if (showServiceTip) {
      return (
        <Alert
          message={
            <span>
              {showServiceTip}{' '}
              亲爱的商家，因服务器波动，导致部分数据显示异常，开发人员正在加紧修复，给您带来的不便敬请谅解。
            </span>
          }
          type="warning"
          showIcon
        />
      )
    }
  }

  getOptimize = warn => {
    const { optimization_num, optimization_type } = warn
    const noOpTip = optimization_num == 0 && optimization_type == 0

    return (
      <div>
        {optimization_num == 1 && (
          <div>
            当前创意数量不足，为保证曝光量和转化，请<Link to={MATERIAL_PATH}>
              上传更多创意；
            </Link>
          </div>
        )}

        {optimization_type == 1 && (
          <div>
            当前创意类型不丰富，为保证曝光量和转化，请<Link to={MATERIAL_PATH}>
              上传更多类型的创意；
            </Link>
          </div>
        )}

        {noOpTip && <span>暂无优化建议</span>}
      </div>
    )
  }

  onTabsInitial = tabStore => {
    this.store.setTabsStore(tabStore)
  }

  render() {
    const { warn } = this.store

    return (
      <Provider pageStore={this.store}>
        <HeaderView contentStyle={{ backgroundColor: 'initial', padding: 0 }}>
          {this.getAlert(warn)}

          <div style={{ marginTop: 10 }}>{this.getServiceAlert(warn)}</div>

          <Flex sp style={{ marginTop: 20 }}>
            <div style={{ marginRight: 20, flex: 1, flexShrink: 0 }}>
              <DashBoard />
              <DeliveryMode />
              <Tabs onInited={this.onTabsInitial} />
            </div>

            <div style={{ flexShrink: 0, width: 320 }}>
              <PackageList />

              <Competition />

              <Panel
                title={
                  <Flex vc>
                    <img
                      src="//qnm.hunliji.com/FoLdq_RR_hplq3laycp3my46e-2S"
                      style={{ marginRight: 10, width: 16 }}
                    />
                    <span>诊断优化</span>
                  </Flex>
                }
              >
                {this.getOptimize(warn)}
              </Panel>
            </div>
          </Flex>
        </HeaderView>
      </Provider>
    )
  }
}
